import { useEffect, useState } from "react";
import { hasAnalyticsConsent } from "@/utils/cookieConsent";

/* Articles this visitor finished, kept only in their browser to mark progress
   along each route. Never sent anywhere; stored only after the visitor accepts
   optional cookies, since it isn't strictly necessary (see the cookie policy). */
const KEY = "lucentia_blog_read";
const EVENT = "lucentia:blog-read";

function readSlugs(): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === "string") : [];
  } catch {
    return [];
  }
}

export function markArticleRead(slug: string) {
  if (!hasAnalyticsConsent()) return;
  try {
    const slugs = readSlugs();
    if (slugs.includes(slug)) return;
    localStorage.setItem(KEY, JSON.stringify([...slugs, slug].slice(-200)));
    window.dispatchEvent(new Event(EVENT));
  } catch {
    /* storage blocked: progress simply isn't remembered */
  }
}

/** Read articles; empty on the server and on the first client render. */
export function useReadArticles(): ReadonlySet<string> {
  const [read, setRead] = useState<ReadonlySet<string>>(() => new Set());
  useEffect(() => {
    const sync = () => setRead(new Set(readSlugs()));
    sync();
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return read;
}
